import type { SortOrder } from "antd/es/table/interface";

type SortMessages = {
  none: string;
  asc: string;
  desc: string;
};

export const getSortLabel = (
  order: SortOrder | null,
  { none, asc, desc }: SortMessages,
) => {
  if (order === "ascend") return asc;
  if (order === "descend") return desc;
  return none;
};